<script>
  import SidebarContext from './SidebarContext.svelte';

  export let testid = undefined;
  export let currentRoute = undefined;
  export let open = false;
</script>

<SidebarContext {currentRoute} {open}>
  <div class='scroll-container' class:open data-cy={testid}>
    <div class='sidebar-main' class:open>
      <slot/>
    </div>
    <div class='gradient'></div>
  </div>
</SidebarContext>

<style lang="postcss">
  .scroll-container {
    --Sidebar--collapsed-width: 60px;

    background: var(--color--white);
    color: var(--color--grey-90);
    box-sizing: border-box;
    
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .sidebar-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    box-sizing: border-box;
    width: var(--Sidebar--collapsed-width);
    
    &.open {
      width: 100%;
      padding: 0 var(--spacing--m);
    }
  }

  .gradient {
    position: sticky;
    bottom: 0;
    height: var(--spacing--xl);
    background-image: linear-gradient(to bottom, transparent 0%, var(--color--white) 50%, var(--color--white) 100%);
  }
</style>
